import { ServiceRequestBase } from "../ServiceRequestBase";

export class UpdateEmailAddressRequest extends ServiceRequestBase {
  public UserId: number | null = null;
  public EmailAddress: string | null = null;
}
